<template>
  <footer class="footer" data-component="footer">
    <div class="container">
      <div class="footer-grid">
        <div class="footer-brand">
          <RouterLink to="/" class="nav-logo">
            <img src="../assets/logo_d.svg" alt="">
          </RouterLink>
          <p>
            国产化AI算力与智能解决方案提供商，以"算力硬件+软件平台+场景应用"为核心，提供自主可控的全栈式智能解决方案。
          </p>
          <div class="footer-social">
            <button type="button" class="footer-social-btn" aria-label="微信" @click="qrOpen = true">
              <svg aria-hidden="true" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                <path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z" />
              </svg>
            </button>
            <a href="mailto:support@hyxino.com" class="footer-social-btn" aria-label="邮件">
              <svg aria-hidden="true" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                <rect x="2" y="4" width="20" height="16" rx="2" />
                <path d="M22 7l-8.97 5.7a1.94 1.94 0 01-2.06 0L2 7" />
              </svg>
            </a>
          </div>
        </div>

        <div class="footer-col">
          <h4>产品方案</h4>
          <RouterLink to="/cloud-gaming">云游戏</RouterLink>
          <RouterLink to="/computing-power">算力服务</RouterLink>
          <RouterLink to="/ai-acceleration">AI加速</RouterLink>
        </div>

        <div class="footer-col">
          <h4>关于公司</h4>
          <RouterLink to="/about-haixi">关于海曦</RouterLink>
          <RouterLink :to="{ path: '/', hash: '#news' }">新闻中心</RouterLink>
          <RouterLink :to="{ path: '/', hash: '#cta-contact' }">加入我们</RouterLink>
          <RouterLink :to="{ path: '/', hash: '#cta-contact' }">联系我们</RouterLink>
        </div>

        <div class="footer-col">
          <h4>联系方式</h4>
          <a href="mailto:support@hyxino.com">support@hyxino.com</a>
          <a href="tel:4000015020">400-001-5020</a>
          <span class="footer-address">上海市浦东新区盛夏路61号</span>
          <span class="footer-address">张润大厦1号楼501室</span>
        </div>
      </div>

      <div class="footer-bottom">
        <p>&copy; 2024-2026 上海海曦技术有限公司 版权所有</p>
        <div class="footer-bottom-links">
          <span class="footer-address">沪ICP备2024072155号-1</span>
          <span class="footer-address">沪公网安备31011502403254号</span>
        </div>
      </div>
    </div>

    <Teleport to="body">
      <div
        v-if="qrOpen"
        class="footer-qr-overlay"
        role="dialog"
        aria-modal="true"
        aria-label="微信公众号二维码"
        @click.self="qrOpen = false"
      >
        <div class="footer-qr-panel">
          <button type="button" class="footer-qr-close" aria-label="关闭" @click="qrOpen = false">×</button>
          <img
            class="footer-qr-img"
            src="@/assets/Rectangle36.png"
            width="200"
            height="200"
            alt="扫码关注海曦技术微信公众号"
          />
          <p class="footer-qr-tip">扫码关注</p>
        </div>
      </div>
    </Teleport>
  </footer>
</template>

<script setup lang="ts">
import { onUnmounted, ref, watch } from 'vue';
import { RouterLink } from 'vue-router';

const qrOpen = ref(false);

function onKeydown(e: KeyboardEvent) {
  if (e.key === 'Escape') qrOpen.value = false;
}

watch(qrOpen, (open) => {
  if (open) {
    document.addEventListener('keydown', onKeydown);
    document.body.style.overflow = 'hidden';
  } else {
    document.removeEventListener('keydown', onKeydown);
    document.body.style.overflow = '';
  }
});

onUnmounted(() => {
  document.removeEventListener('keydown', onKeydown);
  document.body.style.overflow = '';
});
</script>

<style scoped lang="scss">
.footer-qr-overlay {
  position: fixed;
  inset: 0;
  z-index: 200;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(4px);
}

.footer-qr-panel {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 32px 36px 28px;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 20px 48px rgba(0, 0, 0, 0.25);
}

.footer-qr-close {
  position: absolute;
  top: 8px;
  right: 12px;
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  color: #666;
  font-size: 24px;
  line-height: 1;
  cursor: pointer;

  &:hover {
    color: #111;
  }
}

.footer-qr-img {
  display: block;
  width: 200px;
  height: 200px;
  object-fit: cover;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
}

.footer-qr-tip {
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  color: #333;
  letter-spacing: 0.04em;
}
</style>
